import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const TwilioSettingsState = {
  twilioEnableDetails: false,
  twilioSettings: null,
  twilioSettingsLoading: false,
}

export const TwilioSettingsActions = {
  createTwilioSettings: async ({ commit }, value) => {
    commit('setTwilioSettingsLoading', true)

    return axiosRequest.
      post('/admin/site_settings', {
        name: 'twilio',
        value,
      }).
      then(({ data }) => {
        commit('setTwilioEnableDetails', false)
        commit('setTwilioSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setTwilioSettingsLoading', false))
  },

  getTwilioSettings: async ({ commit }) => {
    commit('setTwilioSettingsLoading', true)

    return axiosRequest.
      get('/admin/site_settings/twilio').
      then(({ data }) => {
        commit('setTwilioEnableDetails', false)
        commit('setTwilioSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setTwilioSettingsLoading', false))
  },

  updateTwilioSettings: async ({ commit, getters }, value) => {
    commit('setTwilioSettingsLoading', true)

    return axiosRequest.
      put(`/admin/site_settings/${getters.twilioSettingsId}`, {
        name: 'twilio',
        value,
      }).
      then(({ data }) => {
        commit('setTwilioEnableDetails', false)
        commit('setTwilioSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setTwilioSettingsLoading', false))
  },

  deleteTwilioSettings: async ({ getters, commit }) => {
    commit('setTwilioSettingsLoading', true)

    return axiosRequest.
      delete(`/admin/site_settings/${getters.twilioSettingsId}`).
      then(({ data }) => {
        commit('setTwilioEnableDetails', false)
        commit('setTwilioSettings', data)
        return data
      }).
      catch(handleError).
      finally(_ => commit('setTwilioSettingsLoading', false))
  },

  clearTwilioSettings: ({ commit }) => {
    commit('setTwilioSettings', null)
  },

  setTwilioEnableDetails: ({ commit }, value) => {
    commit('setTwilioEnableDetails', value)
  },
}

export const TwilioSettingsMutations = {
  setTwilioEnableDetails: (state, payload) => { state.twilioEnableDetails = payload },
  setTwilioSettings: (state, payload) => { Vue.set(state, 'twilioSettings', payload) },
  setTwilioSettingsLoading: (state, payload) => { state.twilioSettingsLoading = payload },
  setTwilioSettingsValue: (state, payload) => { Vue.set(state.twilioSettings, 'value', payload) },
}

export const TwilioSettingsGetters = {
  twilioEnableDetails: state => state.twilioEnableDetails,
  twilioSettings: state => state.twilioSettings,
  twilioSettingsId: state => state.twilioSettings?.id,
  twilioSettingsLoading: state => state.twilioSettingsLoading,
  twilioSettingsValue: state => state.twilioSettings?.value,
}
